import React from 'react';

export const DeleteConservationActionActivityFeedItemDescription = props => {
    let conservationActionTypeString = props.CustomEventData ? (props.CustomEventData.contextNode && props.CustomEventData.contextNode.title + " ") : "";

    return <p>
        {props.Event.Activity.User.name} removed a {conservationActionTypeString}Conservation Action.
    </p>;
};



